import { useLocation, useNavigate } from "react-router-dom";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  GridViewIcon,
  StarIcon,
  // UserGroupIcon,
} from "@hugeicons/core-free-icons";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

export function NavProjects() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Projects</SidebarGroupLabel>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton
            tooltip="All projects"
            className="cursor-pointer"
            isActive={location.pathname === "/dashboard/projects"}
            onClick={() => navigate("/dashboard/projects")}
          >
            <HugeiconsIcon icon={GridViewIcon} className="size-4" />
            <span>All projects</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
        <SidebarMenuItem>
          <SidebarMenuButton
            tooltip="Starred"
            className="cursor-pointer"
            isActive={location.pathname === "/dashboard/starred"}
            onClick={() => navigate("/dashboard/starred")}
          >
            <HugeiconsIcon icon={StarIcon} className="size-4" />
            <span>Starred</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
        {/* <SidebarMenuItem>
          <SidebarMenuButton
            tooltip="Shared with me"
            onClick={() => navigate("/dashboard/shared")}
          >
            <HugeiconsIcon icon={UserGroupIcon} className="size-4" />
            <span>Shared with me</span>
          </SidebarMenuButton>
        </SidebarMenuItem> */}
      </SidebarMenu>
    </SidebarGroup>
  );
}
